export const naturesNestBrief = {
  brandName: "Nature's Nest Goa",
  intro: "We've put this together to help us map out the vision for your website redesign. It's designed to be a thoughtful 12-minute deep dive into what makes the property special. Honest answers help us most. — Sachin, Sutranode.",
  addressTeam: true,
  overrides: {}
};
